<template>
  <div id="bpai">
    <ValidationObserver ref="form">
      <div class="row mb-3 container-inputs">
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <label for="">Unidade de saúde</label>
            <vue-select
              :options="estabelecimentos"
              label="no_unidade_saude"
              placeholder=""
              v-model="form.co_ubs"
              :loading="loadingEstabelecimentos"
              :disabled="loadingEstabelecimentos"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_unidade_saude }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <label for="">Mês</label>
            <vue-select
              :options="monthOptions"
              label="label"
              placeholder=""
              v-model="form.mes"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <validation-provider
            v-slot="{ errors }"
            rules="required|onlyNumbers|ano"
          >
            <label for="">Ano</label>
            <input
              type="text"
              class="form-control"
              placeholder=""
              v-model="form.ano"
              v-inputmask="maskNumbers"
              maxlength="4"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }">
            <label for="">Tipo</label>
            <vue-select
              :options="typeOptions"
              label="label"
              placeholder=""
              v-model="form.tipo"
              :clearable="true"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <div class="d-flex justify-content-start container-button-get">
            <button class="btn mt-3" @click="buscar()">Buscar</button>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div class="info-table-item">
            <vue-select
              :loading="loadingProfissionais"
              :disabled="loadingProfissionais"
              v-model="profissionais.selected"
              label="no_prof"
              :options="profissionais.options"
              placeholder="Profissionais"
              @input="handleProfissional"
              class="select-profissionais"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="info-table-item">
            <download-files
              :callback-pdf="generatePdf"
              :data="displayedCadastros"
              :xlsEnabled="false"
              name="bpai"
              :disabled="disabledDownload"
            >
            </download-files>
          </div>
        </div>
        <tabela-cadastros
          ref="table"
          :cadastros="displayedCadastros"
          :loading="loading"
          @filterSearch="filterSearch($event)"
        ></tabela-cadastros>
      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  name: 'BPAI',
  components: {
    TabelaCadastros,
    VueSelect,
    Selects,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros.map((item, index) => {
        let endereco =
          item.contato_endereco != null
            ? JSON.parse(item.contato_endereco)
            : {
                sg_uf: '',
                ds_cep: '',
                no_bairro: '',
                nu_numero: '',
                no_municipio: '',
                ds_logradouro: '',
                ds_complemento: '',
                no_tipo_logradouro: '',
                nu_telefone_celular: '',
                nu_telefone_contato: '',
              }

        return {
          index: index,
          ...item,
          endereco: endereco,
        }
      })
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  data() {
    return {
      equipe: '',
      cadastros: [],
      totalItems: 0,
      loading: false,
      equipName: '',
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      month: '',
      disabledMonth: true,
      cadastrosOriginais: [],
      filterSearchTable: false,
      profissionais: {
        options: [],
        selected: '',
      },
      form: {
        co_ubs: null,
        mes: '',
        ano: '',
        tipo: {
          label: 'Exclusivamente BPA I',
          value: 'bpai',
        },
      },
      disabledDownload: true,
      loadingProfissionais: false,
      loadingEstabelecimentos: false,
      estabelecimentos: [],
      typeOptions: [
        {
          label: 'Exclusivamente BPA I',
          value: 'bpai',
        },
        {
          label: 'BPA I ou BPA C',
          value: 'bpai-ou-bpac',
        },
      ],
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Retorna o mês atual
     *
     * @returns {String}
     */
    getCurrentMonth() {
      const date = new Date()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return month
    },

    /**
     * Manipula ao selecionar um profissional
     *
     * @param {Object} value
     */
    handleProfissional(value) {
      this.profissionais.selected = value
      this.cadastros = this.cadastrosOriginais
      if (value === null) {
        this.disabledDownload = true
        return
      }
      this.disabledDownload = false
      this.cadastros = this.cadastros.filter(
        (item) => item.co_dim_profissional === value.co_prof
      )
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarEstabelecimentos() {
      try {
        this.loadingEstabelecimentos = true
        let response = await this.$api.get(
          `/app/bpa-i/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingEstabelecimentos = false
      }
    },

    /**
     * Busca os dados
     */
    async buscar() {
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }
        this.loading = true
        this.loadingProfissionais = true
        const response = await Functions.getDados(
          this.$store.state.cod_ibge,
          this.form.co_ubs.co_ubs,
          this.form.mes.value,
          this.form.ano,
          this.form.tipo
        )
        this.profissionais.selected = null
        const responseProfissionais = await Functions.getProfissionais(
          this.$store.state.cod_ibge,
          this.form.co_ubs.co_ubs,
          this.form.mes.value,
          this.form.ano,
          this.form.tipo
        )
        if (responseProfissionais) {
          this.profissionais.options = responseProfissionais.map(
            (item, index) => ({
              ...item,
              id: index,
            })
          )
        }
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
          this.totalItems = response.length
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
        this.loadingProfissionais = false
      }

      return
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.$store.state.cod_ibge,
        this.form.co_ubs.co_ubs,
        this.form.mes.value,
        this.form.ano,
        this.profissionais.selected
      )
    },
  },
  async created() {
    await this.carregarEstabelecimentos()
  },
}
</script>

<style lang="scss" src="./styles.scss" scoped></style>
